import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SideMenusService {
  public toggleMainMenuSubject: Subject<'open' | 'close' | 'toggle'> = new Subject();

  public toggleAltMenuSubject: Subject<any> = new Subject();
  public renderAltMenuSubject: Subject<any> = new Subject();

  public changeMainMenuModeSubject: Subject<any> = new Subject();

  constructor() {}
  toggleMainMenu() {
    this.toggleMainMenuSubject.next('toggle'); // Emit toggle event
  }

  closeMainMenu() {
    this.toggleMainMenuSubject.next('close'); // Emit 'close' when menu should be closed
  }
}
